export enum KPIMetricsEnum {
  SyteRevenue = 'syte_revenue',
  Clicks = 'button_clicks',
  CTR = 'ctr',
  Transactions = 'transactions',
  CVR = 'cvr',
  AOV = 'aov',
  ARPU = 'arpu',
}

export enum KpiGranularity {
  Day = 'day',
  Week = 'week',
  Month = 'month',
}

export const getGranularityLabel = (granularity: KpiGranularity): string => {
  switch (granularity) {
    case KpiGranularity.Day:
      return 'Day';
    case KpiGranularity.Week:
      return 'Week';
    case KpiGranularity.Month:
      return 'Month';
    default:
      return 'Day';
  }
};

export const getKPILabel = (kpi: KPIMetricsEnum): string => {
  switch (kpi) {
    case KPIMetricsEnum.Clicks:
      return 'Clicks';
    case KPIMetricsEnum.CTR:
      return 'CTR';
    case KPIMetricsEnum.Transactions:
      return 'Transactions';
    case KPIMetricsEnum.CVR:
      return 'CVR';
    case KPIMetricsEnum.SyteRevenue:
      return 'Syte Revenue';
    case KPIMetricsEnum.AOV:
      return 'AOV';
    case KPIMetricsEnum.ARPU:
      return 'ARPU';
    default:
      return 'Syte Revenue';
  }
};
